// @ts-nocheck

import { BetBuilderActionTypes } from '../../../types/actions/betbuilder';

const basketUpdateBetbuilderOdd = (state, action) => {
  if (
    action.type === BetBuilderActionTypes.BASKET_UPDATE_BETBUILDER_ODD &&
    state.items[action.payload.basketBetbuilderId]?.value !== action.payload.value &&
    !state.items[action.payload.basketBetbuilderId].cashout
  ) {
    return {
      ...state,
      items: {
        ...state.items,
        [action.payload.basketBetbuilderId]: {
          ...state.items[action.payload.basketBetbuilderId],
          changed: true,
          value: action.payload.value,
        },
      },
    };
  } else {
    return state;
  }
};

export default basketUpdateBetbuilderOdd;
